import { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { composeDocument } from '../../lib/portal'

export default function ComposeDocumentPage() {
  const navigate = useNavigate()
  const [title, setTitle] = useState('')
  const [text, setText]   = useState('')
  const [busy, setBusy]   = useState(false)
  const [error, setError] = useState<string | null>(null)

  const submit = async () => {
    if (!text.trim()) { setError('Belge metni boş olamaz.'); return }
    setBusy(true); setError(null)
    try {
      const doc = await composeDocument(title.trim() || 'Belge', text)
      navigate(`/documents/${doc.id}`)
    } catch {
      setError('Belge oluşturulamadı.')
      setBusy(false)
    }
  }

  return (
    <>
      <Helmet><title>Belge oluştur — W.Sign</title><meta name="robots" content="noindex, nofollow" /></Helmet>
      <section className="container-page py-12 max-w-3xl">
        <h1 className="text-3xl font-semibold">Metinden belge oluştur</h1>
        <p className="mt-2 text-[var(--color-fg-muted)]">
          Metni yazın; PDF'e dönüştürülüp imzalanmaya hazır hale getirilecek.
        </p>

        <div className="card mt-6 space-y-4">
          <label className="block">
            <span className="text-xs font-semibold uppercase tracking-wide text-[var(--color-fg-muted)]">Başlık</span>
            <input
              type="text" value={title} placeholder="Örn. Hizmet Sözleşmesi"
              onChange={e => setTitle(e.target.value)}
              className="mt-1 block w-full rounded-md border border-[var(--color-border)] bg-white px-3 py-2 text-sm focus:border-[var(--color-accent)] focus:outline-none"
            />
          </label>
          <label className="block">
            <span className="text-xs font-semibold uppercase tracking-wide text-[var(--color-fg-muted)]">Belge metni</span>
            <textarea
              value={text} rows={14} placeholder="Belge içeriğini buraya yazın…"
              onChange={e => setText(e.target.value)}
              className="mt-1 block w-full rounded-md border border-[var(--color-border)] bg-white px-3 py-2 text-sm font-mono focus:border-[var(--color-accent)] focus:outline-none"
            />
          </label>
          <div className="flex items-center gap-3">
            <button onClick={submit} disabled={busy} type="button" className="btn-primary">
              {busy ? 'Oluşturuluyor…' : 'PDF oluştur'}
            </button>
            {error && <span className="text-sm text-red-700">{error}</span>}
          </div>
        </div>
      </section>
    </>
  )
}
